export const AUTH_CAMPAIGN_PARAM_ID = 'campaignId';

export enum CampaignIds {
  PHYSICAL_CARD = 'link-card',
}
